import { GameConstants } from "./GameConstants";

export class GameVars {

    public static scaleX: number;
    public static language: string;
    public static paused: boolean;
    public static typeAd: string;

    public static gameWidth: number;
    public static gameHeight: number;
    
    private static _instance: GameVars = null;
            
    private _cards: CardValue[];
    private _reshuffles: number;
    private _hints: number;
    private _time: number;
    private _shuffling: boolean;
    private _simulateStartedGame: boolean;
    private _retrieveSavedGame: boolean;
    private _aboutToFinish: boolean;
    private _gameConcluded: boolean;
    private _savedGameStateData: GameStateData;
    private _originPileData: PileData;
    private _destinyPileData: PileData;
    private _bestTime: number;

    public static areValidDomains(domains: string[]): boolean {

        const hostname = window.location.hostname;
        const referrer = document.referrer;

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {

                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static getInstance(): GameVars {

        if (GameVars._instance === null) {
            GameVars._instance = new GameVars();
        }
        
        return GameVars._instance;
    }

    constructor() {

        if (GameVars._instance) {
            throw new Error("Error: Instantiation failed: Use GameVars.getInstance() instead of news");
        } else {
            GameVars._instance = this;
        }  
    }

    public init(): void {
        
        // GameState.startLayerShown = true;
        // this._simulateStartedGame = true;
        
        this._aboutToFinish = false;
        this._retrieveSavedGame = false;
        this._cards = new Array();   
        
        var value: string;
        
        for (var i: number = 0; i < 4; i++) {
            for (var j: number = 1; j < 14; j++) {
                
                if (j === 1) {
                    value = "A";
                } else if ( j === 11) {
                    value = "J";
                } else if ( j === 12) {
                    value = "Q";
                } else if ( j === 13) {
                    value = "K";
                } else {
                    value = j.toString();
                }

                this._cards.push({value: value, suit: i});
            }  
        }  
        
        // cloning the array but not including aces or kings
        var tmpArray: CardValue[] = new Array();
        
        for (var i: number = 0; i < this._cards.length; i++) {
        
            if (this._cards[i].value !== "K" && this._cards[i].value !== "A" ) {
                tmpArray.push(this.cards[i]);
            }
        }
        
        // concatenamos el array
        this._cards = this._cards.concat(tmpArray);
        
        // si hay un estado grabado
        let savedGameStateDataString: string = GameVars.getInstance().getLocalStorageData(GameConstants.GAME_STATE_KEY);

        if ( savedGameStateDataString !== "") {
            this._savedGameStateData = JSON.parse(savedGameStateDataString);
        } else {
            this._savedGameStateData = null;
        }
        
        // record the tiempo
        let bestTimeString: string = GameVars.getInstance().getLocalStorageData(GameConstants.BEST_TIME_KEY);

        if ( bestTimeString !== "") {
            this._bestTime = parseInt(bestTimeString);   
        } else {
            this._bestTime = GameConstants.TIME;
        }
    }
    
    public formatTime(time: number): string {

        const minutes = Math.floor (time / 60 );
        const seconds = time - minutes * 60;
        
        const minutesString = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
        const secondsStr = seconds < 10 ? "0" + seconds.toString() : seconds.toString();

        return minutesString + ":" + secondsStr;
    }
    
    public getLocalStorageData (keyName: string): string {
        
        try {
            const value = localStorage.getItem(keyName);

            if (value !== null) {
                return value;
            } else {
                return "";
            }
        } catch {
            return "";
        }
        
    }

    public setLocalStorageData(keyName: string, value: string ): void {
        try {
            localStorage.setItem( keyName, value );
        } catch {

        }

    }
    
    public get cards(): CardValue[] {
        
        return this._cards;
    }
    
    public get reshuffles(): number {
        return this._reshuffles;
    }
    
    public set reshuffles(value: number) {
        this._reshuffles = value;
    }
    
    public get hints(): number {
        return this._hints;
    }
    
    public set hints(value: number) {
        this._hints = value;
    }
    
    public get shuffling(): boolean {
        return this._shuffling;
    }
    
    public get time(): number {
        return this._time;
    }
    
    public set time(value: number) {
        this._time = value;
    }
    
    public set shuffling(value: boolean) {
        this._shuffling = value;
    }
    
    public get simulatesStartedGame(): boolean {
        return this._simulateStartedGame;
    }
    
    public set simulatesStartedGame(value: boolean) {
        this._simulateStartedGame = value;
    }
    
    public get aboutToFinish(): boolean {
        return this._aboutToFinish;
    }
    
    public set aboutToFinish(value: boolean) {
        this._aboutToFinish = value;
    }
    
    public get gameConcluded(): boolean {
        return this._gameConcluded;
    }
    
    public set gameConcluded(value: boolean) {
        this._gameConcluded = value;
    }
    
    public get retrieveSavedGame(): boolean {
        return this._retrieveSavedGame;
    }
    
    public set retrieveSavedGame(value: boolean) {
        this._retrieveSavedGame = value;
    }
    
    public get savedGameStateData(): GameStateData {
        return this._savedGameStateData;
    }
    
    public set savedGameStateData(value: GameStateData) {
        
        this._savedGameStateData = value;
        
        this.setLocalStorageData(GameConstants.GAME_STATE_KEY, JSON.stringify(this._savedGameStateData));  
    }
    
    public get originPileData(): PileData {
        return this._originPileData;
    }
    
    public set originPileData(value: PileData) {
        this._originPileData = value;
    }
    
    public get destinyPileData(): PileData {
        return this._destinyPileData;
    }
    
    public set destinyPileData(value: PileData) {
        this._destinyPileData = value;
    }
    
    public get bestTime(): number {
        return this._bestTime;
    }
    
    public set bestTime(value: number) {
        
        this._bestTime = value;
        this.setLocalStorageData(GameConstants.BEST_TIME_KEY, this._bestTime.toString());  
    }
}

